import React, { useState, useEffect } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";

// --- REPLACE THESE 3 VALUES ---
const GOOGLE_CLIENT_ID = "325126705795-r5gj04kni46qna4ulqfojmd7raes5opr.apps.googleusercontent.com";
// const N8N_WEBHOOK_URL = "https://n8n.splendidmark.com/webhook-test/c662668a-448b-4032-ab32-55f2847d4209";
const N8N_WEBHOOK_URL = "https://n8n.splendidmark.com/webhook/c662668a-448b-4032-ab32-55f2847d4209";

const GOOGLE_MEET_LINK = "https://meet.google.com/bch-zdtt-afb";

function App() {
  // State to hold user information
  const [user, setUser] = useState(null);

  // This runs once when the app first loads
  useEffect(() => {
    // Check if user info is already saved in localStorage
    const savedUser = localStorage.getItem('attendanceUser');
    console.log(savedUser,"asdf");
    
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleLoginSuccess = (credentialResponse) => {
    const userProfile = jwtDecode(credentialResponse.credential);
    console.log("Login Success:", userProfile);

    const userData = {
      email: userProfile.email,
      name: userProfile.name,
    };

    // Save user to localStorage and set the state
    localStorage.setItem('attendanceUser', JSON.stringify(userData));
    setUser(userData);
    
    // Log attendance and proceed
    logAttendanceAndProceed(userData);
  };

  const logAttendanceAndProceed = (currentUser) => {
    // Construct the URL with query parameters
    const webhookUrlWithParams = new URL(N8N_WEBHOOK_URL);
    webhookUrlWithParams.searchParams.append('email', currentUser.email);
    webhookUrlWithParams.searchParams.append('name', currentUser.name);
    webhookUrlWithParams.searchParams.append('timestamp', new Date().toISOString());

    // Send data to n8n webhook and then redirect
    fetch(webhookUrlWithParams)
      .then(response => {
        if (!response.ok) {
          console.error("Failed to log attendance");
        }
        window.location.href = GOOGLE_MEET_LINK;
      })
      .catch(error => {
        console.error("Error sending data to webhook:", error);
        window.location.href = GOOGLE_MEET_LINK;
      });
  };

  const handleLogout = () => {
    // Clear user from state and localStorage
    setUser(null);
    localStorage.removeItem('attendanceUser');
  };

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', textAlign: 'center' }}>
        {user ? (
          // If user is logged in, show welcome message
          <div>
            <h1>Welcome back, {user.name}!</h1>
            <p>Your attendance will be logged automatically.</p>
            <button onClick={() => logAttendanceAndProceed(user)} style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer' }}>
              Join Meeting
            </button>
            <br />
            <button onClick={handleLogout} style={{ marginTop: '10px', background: 'transparent', border: 'none', color: 'gray', cursor: 'pointer' }}>
              (Sign out)
            </button>
          </div>
        ) : (
          // If user is not logged in, show the Google Sign-In button
          <div>
            <h1>Join Daily Standup</h1>
            <p>Please sign in to log your attendance and join the meeting.</p>
            <br />
            <GoogleLogin onSuccess={handleLoginSuccess}  
            useOneTap={false} />
            
          </div>
        )}
      </div>
    </GoogleOAuthProvider>
  );
}

export default App;